export default async () => {
    const result = await app.fetch('ajax/price_vat_all.php', { mode: 1 });

    return result;
};
